import { render, staticRenderFns } from "./u-tit-medium.vue?vue&type=template&id=77697bc0&scoped=true"
import script from "./u-tit-medium.vue?vue&type=script&lang=js"
export * from "./u-tit-medium.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77697bc0",
  null
  
)

export default component.exports